const STOP = new Set([
  'a',
  'an',
  'the',
  'to',
  'of',
  'and',
  'or',
  'for',
  'in',
  'on',
  'at',
  'my',
  'me',
  'i',
  'be',
  'by',
  'with',
  'this',
  'that',
  'it',
  'is',
  'every',
  'day',
  'daily',
  'more',
  'get',
  'go',
])

const CJK = /[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Hangul}]/u

function words(title: string): Set<string> {
  return new Set(
    title
      .toLowerCase()
      .replace(/[^\p{L}\p{N}\s]/gu, ' ')
      .split(/\s+/)
      .filter((w) => w.length > 1 && !STOP.has(w))
      .map((w) => (w.length > 3 && w.endsWith('s') && !w.endsWith('ss') ? w.slice(0, -1) : w)),
  )
}

// Meaningful words two titles share ("buy shoes" / "buy running shoes" → 2).
export function sharedTitleWords(a: string, b: string): number {
  const wb = words(b)
  let shared = 0
  for (const w of words(a)) if (wb.has(w)) shared++
  return shared
}

// Loose "is this the same goal/habit/task?" check for capture dedupe: exact match after
// normalising, or most of the shorter title's meaningful words appear in the other.
export function isSimilarTitle(a: string, b: string): boolean {
  const wa = words(a)
  const wb = words(b)
  if (!wa.size || !wb.size) return false
  const ca = [...wa].join('')
  const cb = [...wb].join('')
  // "hair cut" vs "haircut"
  if (ca === cb) return true
  // CJK titles have no spaces to split on, so compare the whole phrase by containment.
  if (CJK.test(ca) || CJK.test(cb)) {
    const [short, long] = ca.length <= cb.length ? [ca, cb] : [cb, ca]
    if (short.length >= 2 && long.includes(short)) return true
  }
  let shared = 0
  for (const w of wa) if (wb.has(w)) shared++
  const smaller = Math.min(wa.size, wb.size)
  return shared === smaller || (shared >= 2 && shared / smaller >= 0.6)
}
